<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <a @click="$router.go(-1)"><i class="fa fa-arrow-left" aria-hidden="true"></i></a> 
                    <h3 class="mb-0">
                        {{ $t('message.add') }} {{ $tc('message.subscribers', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <b-row>
                    <b-col sm="12">
                        <div class="vgt-global-search vgt-clearfix">

                            <div class="vgt-global-search__input vgt-pull-left"><span class="input__icon">
                                        <div class="magnifying-glass">

                                        </div>
                                    </span>
                                <input type="text" placeholder="Search user" class="vgt-input vgt-pull-left" v-model="searchTerm">
                            </div>
                            <div class="vgt-global-search__actions vgt-pull-right">

                            </div>
                        </div>
                        <vue-good-table
                                id="operation"
                                :columns="mSubscribersColumns"
                                :rows="mSubscribersFilter"
                                :search-options="{
                                        enabled:true,
                                        externalQuery: searchTerm
                                        }"
                                :pagination-options="paginationOptions"
                                @on-row-click="onSubscriberClick"
                        />
                    </b-col>

                    <p class="mt-2 ml-3">{{$tc('message.subscribers',2)}} : </p>
                    <p style="color: red" class="mt-2" v-if="$v.souscripteurs.$error"> {{ $t('message.requiredField') }} </p>

                    <b-col sm="12">
                        <div v-if="souscripteurs.length >0">
                            <b-row v-for="souscripteur in souscripteurs"  :key="souscripteur.value" class="mb-2">
                                <b-col sm="8">{{souscripteur.text}}</b-col>
                                <b-col sm="4">
                                    <button type="button" class=" ml-5 btn btn-danger btn-sm" @click="deleteSubscriber(souscripteur)">{{$t('message.delete')}}</button>
                                </b-col>
                            </b-row>
                        </div>
                    </b-col>
                </b-row>
                <b-row class="justify-content-sm-center">

                    <b-button @click="onSubmit" variant="primary" v-if="can || hasAssistante">
                        {{ $t('message.save') }}
                    </b-button>
                </b-row>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { required, email, minLength,integer } from 'vuelidate/lib/validators';
    import _ from 'lodash';
    import SlimSelect from 'slim-select';
    import moment from "moment";

    export default {
        name: "AddSouscripteur",

        computed: {
            ...mapGetters(["countries", "subscribers", "errors", 'hasAdminRole',
                'hasGestionnaireRole', 'hasPraticienRole','hasMedecinControleRole','hasAssistante',
            ]),

            userIsMed: function () {
                return (JSON.parse(localStorage.getItem('user')))['isMedicasure'];
            },

            can:function(){
                return (this.hasAdminRole || this.hasGestionnaireRole || this.hasPraticienRole || this.hasMedecinControleRole || this.hasAssistante) && this.userIsMed;
            },

            mSubscribers: function() {
                let sArray = [];

                _.forOwn(this.subscribers, function(value, key) {
                    if (!_.isNull(value.user)){
                        let prenom  = value.user.prenom ? value.user.prenom : "";
                        prenom =  prenom.toLowerCase();
                        let fullName = (value.user.nom).toUpperCase()+ " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
                        sArray.push({ text: fullName, value: value.user.id });
                    }
                });

                return sArray;
            },
        },

        data() {
            return {
                patient_id: this.$route.params.patient,
                souscripteurs:[],
                item: {text: 'Selectionner un souscripteur ci-dessous', value: 0},
                searchTerm: '',
                paginationOptions: {
                    enabled: true,
                    mode: 'records',
                    perPageDropdown: [3, 6, 10]
                },
                mSubscribersFilter:[],
                mSubscribersColumns: [
                    {
                        field: 'text',
                        label: this.$i18n.t('message.name'),
                    },
                ],
            }
        },

        watch:{

            searchTerm:function (newValue, oldValue) {
                if (!this.hasPatientRole){
                    if (newValue.trim().length ==0){
                        this.mSubscribersFilter = [];
                    }else{
                        this.mSubscribersFilter = this.mSubscribers;
                    }
                }else{
                    this.mSubscribersFilter =this.mSubscribers;
                }
            }
        },

        methods: {
            deleteSubscriber(souscripteur){
               let index = _.findIndex(this.souscripteurs,function (item) {
                    return souscripteur.value == item.value;
                })

                if (index != "-1"){
                    this.souscripteurs.splice(index,1);
                }
            },

            onSubscriberClick(params) {
                // this.$router.push({ name: 'patient', params: { patient: params.row.value } });
                if ("-1" == _.findIndex(this.souscripteurs,function (souscripteur) {
                    return souscripteur.value == params.row.value;
                })){
                    this.souscripteurs.push({text: params.row.text, value: params.row.value});
                    this.searchTerm = '';
                }
            },

            getSubscribers: function() {
                let args = {};
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('getSubscribers', { args, errorMessages });
            },

            onSubmit: function(evt) {
                evt.preventDefault();

                this.$v.$touch();

                // createPatientInstitution

                if(!this.$v.$invalid) {
                    let financeur_id = [];

                    _.forEach(this.souscripteurs ,function (souscripteur) {
                        financeur_id.push(souscripteur.value);
                    });

                    let args = {
                        patient_id: this.patient_id,
                        financable_type:'Souscripteur',
                        financable_id:financeur_id
                    };

                    let successMessage = this.$i18n.t('message.subscriberCreated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('createPatientSubscribers', { args, errorMessages, successMessage });
                }
            },

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },

            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });

                this.getErrorsField(field);
            }
        },

        validations() {
            return {
                souscripteurs:{
                    required
                }
            }
        },

        mounted() {
            // Retrieve list of subscribers
            this.getSubscribers();

            new SlimSelect({
                select: '#souscripteur',
                placeholder: 'Select country'
            });

        }
    }
</script>

<style scoped>

</style>
